import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { EmailauthPage } from './emailauth';

@NgModule({
  declarations: [
    EmailauthPage,
  ],
  imports: [
    IonicPageModule.forChild(EmailauthPage),
  ],
})
export class EmailauthPageModule {}



// WEBPACK FOOTER //
// ./src/pages/emailauth/emailauth.module.ts